// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".startup-investors .more[data-v-633ac5e0]{margin-top:2rem;display:inline-block;font-weight:700;color:#443fdb!important;cursor:pointer}.startup-investors .more>i[data-v-633ac5e0]{font-size:.7rem;margin-left:.3rem}", ""]);
// Exports
module.exports = exports;
